import React, { useState } from "react";


import MenuBar from "../components/MenuBar";
import TmapRouteMap from "../TmapRouteMap";

const TMapExample = () => {
  const [routeInfo, setRouteInfo] = useState(null);

  return (
    <div>
     
     <TmapRouteMap  />
    </div>
  );
};

export default TMapExample;
